import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { StockPolicySection } from '../../../features/settings/stock-policy-section'

export const Route = createFileRoute('/_app/settings/stock-policy')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'stock-policy'),
  component: StockPolicySection,
})
